import { useEffect, useState } from "react";
import { IDashboardStats, UserPartsStats, UserStats } from "../../models/DashboardStats";
import DashboardTile from "./DashboardTile";
import PriceFormat from '../../utils/priceFormat';
import DashboardStatTableTabs from "../shared/Tabs/DashboardStatTableTabs";

const tabs = [
  { name: 'Today', value: 'today' },
  { name: 'Week', value: 'week' },
  { name: 'Month', value: 'month' },
];

interface IActivityTableProps {
  dashboardStats: IDashboardStats;
  dayKey: StatKey;
  weekKey: StatKey;
  monthKey: StatKey;
  title: string;
  keyCol: string;
}

type StatKey = keyof IDashboardStats;

export default function PartsRemovedActivityTable({
  dashboardStats,
  dayKey,
  weekKey,
  monthKey,
  title,
  keyCol,
}: IActivityTableProps) {
  const [timeframe, setTimeframe] = useState("today");
  const [stats, setStats] = useState<{ [key: string]: UserStats } | undefined>(undefined);

  useEffect(() => {
    if (dashboardStats) {
      switch (timeframe) {
        case "today":
          let dayStats = dashboardStats[dayKey] as { [key: string]: UserStats };
          setStats(dayStats);
          break;
        case "week":
          let weekStats = dashboardStats[weekKey] as { [key: string]: UserStats };
          setStats(weekStats);
          break;
        case "month":
          let monthStats = dashboardStats[monthKey] as { [key: string]: UserStats };
          setStats(monthStats);
          break;
      }
    }
  }, [dashboardStats, timeframe]);

  return (
    <DashboardTile span={2}>
      <div className="p-3">
        <div className="mb-3 w-full flex justify-between">
          <div className="prose">
            <h3>{title}</h3>
          </div>

          <DashboardStatTableTabs
            tabs={tabs}
            value={timeframe}
            onChange={setTimeframe}
            ariaLabel="Select a tab"
          />

        </div>

        <div className="mt-6">
          <div className="grid grid-cols-4 text-right">
            <p className="text-left">{keyCol}</p>
            <p>Engines</p>
            <p>Total Price</p>
            <p>Removed</p>
          </div>

          <hr />

          <div className="mt-4 flex flex-col divide-y gap-y-2">
            {stats && Object.keys(stats).map((key) => {
              if (stats[key]) {
                return (
                  <div key={key} className="grid grid-cols-4 pt-2 font-semibold text-right">
                    <p className="text-left">{key}</p>
                    <p className="font-bold text-xl text-primary-600">{stats[key].enginesRemoved}</p>
                    <p className="font-bold text-xl text-primary-600">{PriceFormat(stats[key].totalPrice)}</p>
                    <p className="font-bold text-xl text-primary-600">{stats[key].removedCount}</p>
                  </div>
                )
              }
            })}
          </div>
        </div>

      </div>
    </DashboardTile>
  );

}